import type { Key } from 'react-aria';
import { Tab, TabList, TabPanel, Tabs } from '@launchpad-ui/components';

import { SIGNUP_TAB_ENTERPRISE_DEMO, SIGNUP_TAB_TRIAL } from '#utils/tracking/signupEnterpriseDemo';

import { EnterpriseDemoSignupForm } from './EnterpriseDemoSignupForm';
import { OAuthButtons } from './OAuthButtons';
import { SignUpForm } from './SignUpForm';

import styles from './SignUpIntentTabs.module.css';

const TAB_TRIAL = SIGNUP_TAB_TRIAL;
const TAB_ENTERPRISE_DEMO = SIGNUP_TAB_ENTERPRISE_DEMO;

type SignUpIntentTabsProps = {
  selectedTab: string;
  onSelectedTabChange: (tab: string) => void;
  oauthRedirectPath?: string;
};

export const SignUpIntentTabs = ({
  selectedTab,
  onSelectedTabChange,
  oauthRedirectPath = '/signup',
}: SignUpIntentTabsProps) => {
  const handleTabChange = (key: Key) => {
    onSelectedTabChange(String(key));
  };

  return (
    <Tabs selectedKey={selectedTab} onSelectionChange={handleTabChange} className={styles.tabs}>
      {/* TabList must be a direct child of Tabs (no wrapper) so Launchpad panels layout correctly. */}
      <TabList aria-label="Sign up options" className={styles.tabList}>
        <Tab id={TAB_TRIAL} className={styles.tab}>
          Start 14-Day Trial
        </Tab>
        <Tab id={TAB_ENTERPRISE_DEMO} className={styles.tab}>
          Enterprise Sales
        </Tab>
      </TabList>
      <TabPanel id={TAB_TRIAL} className={styles.tabPanel}>
        <OAuthButtons oauthRedirectPath={oauthRedirectPath} />
        <section>
          <SignUpForm hideDemoLink />
        </section>
      </TabPanel>
      <TabPanel id={TAB_ENTERPRISE_DEMO} className={styles.tabPanel}>
        <section>
          <EnterpriseDemoSignupForm />
        </section>
      </TabPanel>
    </Tabs>
  );
};
